// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Customer from '../components/Customer';
import {actions as CustomersActions} from '../duck';
import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    currency: state.currency.currency,
    country: state.country.country,
    store: state.store.store,
    user: state.auth.user,
    message: state.crm.message,
    customer: state.crm.customer,
    orderPagination: state.crm.orderPagination,
    isFetching: state.crm.isFetchingCustomer,
    isFetchingOrders: state.crm.isFetchingOrders,
    orders: state.crm.orders,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...CustomersActions,
      },
      dispatch
    )
)(Customer);
